import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PageBaseComponent } from '../page-base/page-base.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-tablepage-base',
  standalone: true,
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    PageBaseComponent,
    TranslatePipe
  ],
  templateUrl: './tablepage-base.component.html',
  styleUrls: ['./tablepage-base.component.css']
})
export class TablepageBaseComponent {
  @Input() loading = false; // Riceve lo stato dalla pagina figlia
}
